var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-link',{staticClass:"app-name",attrs:{"underline":false,"href":"/"}},[_vm._v("\n  "+_vm._s(_vm.$t('APP.NAME'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }